module.exports = __webpack_public_path__ + "images/emoji/-1.5a9b5d4ca21a3d76963d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/-1.png
// module id = WhMb
// module chunks = 1